$mol_view_tree2_to_js_test_ex_simple_mutable_and_read_only_foo $mol_object
	readonly null
	mutable? null
